// /* eslint-disable @typescript-eslint/no-unused-vars */
/* eslint-disable react-hooks/exhaustive-deps */
/* eslint-disable @typescript-eslint/no-explicit-any */
// import { useToast } from "@/hooks/use-toast";
import { zodResolver } from "@hookform/resolvers/zod";
import { useEffect } from "react";
import { useForm } from "react-hook-form";

import { z } from "zod";

type UseUserformType = {
  formData: any;
  onFormSubmit: (prop: any) => Promise<any>;
  open: boolean;
  onOpenChange: (prop: boolean) => void;
};

const formSchema = z.object({
  email_id: z.string().email({
    message: "Invalid email address.",
  }),
  password: z.string().optional(),
  enable: z.boolean().optional(),
  read_body_content: z.boolean().optional(),
  read_attachments: z.boolean().optional(),
  settings: z
    .object({
      sender_emails: z.array(z.string()).optional(),
      subject: z.array(z.string()).optional(),
      supported_document_types: z.array(z.string()).optional(),
      ignore_document_types: z.array(z.string()).optional(),
      read_body_content_for_ignored_attachments: z.boolean().optional(),
      sender_email_settings: z.any(),
      download_attachment_from_url: z.boolean().optional(),
      trusted_domains: z.any().optional(),
      email_provider: z.any(),
    })
    .optional(),
  azure_app_settings: z
    .object({
      tenant_id: z.any().optional(),
    })
    .optional(),
});

export const useReactForm = ({
  formData,
  onFormSubmit,
  onOpenChange,
}: // open,
UseUserformType) => {
  // const { toast } = useToast();
  const schemaKeys = formSchema.keyof().options;

  const form = useForm<z.infer<typeof formSchema>>({
    resolver: zodResolver(formSchema),
    mode: "onBlur",
    defaultValues: {
      email_id: "",
      password: "",
      enable: false,
      read_attachments: false,
      read_body_content: false,
      azure_app_settings: {
        tenant_id: "",
      },
    },
    shouldUnregister: true,
  });

  useEffect(() => {
    if (formData && Object.keys(formData).length > 0) {
      schemaKeys.forEach((key) => {
        if (formData[key]) {
          const value = formData[key];
          form.setValue(key, value, {
            shouldTouch: true,
            shouldDirty: true,
          });
        }
      });
    }
    if (formData?.settings?.sender_emails) {
      form.setValue(
        "settings.sender_emails",
        formData?.settings?.sender_emails,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    }
    if (formData?.settings?.subject) {
      form.setValue("settings.subject", formData?.settings?.subject, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.supported_document_types) {
      form.setValue(
        "settings.supported_document_types",
        formData?.settings.supported_document_types,
        {
          shouldTouch: true,
          shouldDirty: true,
        },
      );
    }
    if (formData?.settings?.sender_email_settings) {
      const temp_data = formData?.settings?.sender_email_settings;
      const tempArray = [];
      if (Object.keys(temp_data).length > 0) {
        for (const key in temp_data) {
          if (temp_data[key]) {
            tempArray.push({ ...temp_data[key], email: key });
          }
        }
      }
      console.log({ tempArray });
      form.setValue("settings.sender_email_settings", tempArray, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    if (formData?.settings?.download_attachment_from_url) {
      const temp_data = formData?.settings?.download_attachment_from_url;
      form.setValue("settings.download_attachment_from_url", temp_data, {
        shouldTouch: true,
        shouldDirty: true,
      });
    }
    console.log("formData", formData);
  }, [formData]);

  async function onSubmit(values: z.infer<typeof formSchema>) {
    const sender_email_settings = values?.settings?.sender_email_settings;
    const temp_object: any = {};
    for (const key in sender_email_settings) {
      const temp_val = sender_email_settings[key];
      const email = temp_val.email;
      if (email !== "" && temp_object[email] === undefined) {
        delete temp_val.email;
        temp_object[email] = temp_val;
      }
    }

    if (values?.settings?.sender_email_settings) {
      values.settings.sender_email_settings = temp_object;
    }

    // delete values?.settings?.sender_email_settings;
    console.log({ values, sender_email_settings, temp_object });
    const { data } = await onFormSubmit(values);
    if (data) {
      onOpenChange(false);
    }
  }

  return { form, onSubmit };
};
